import { render, staticRenderFns } from "./JumpGameReport.vue?vue&type=template&id=088073b8&scoped=true"
import script from "./JumpGameReport.vue?vue&type=script&lang=js"
export * from "./JumpGameReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088073b8",
  null
  
)

export default component.exports